export default __webpack_public_path__ + "media/72fca9fde3b739bcbc1dbf60643d21d076545c9f4704f7c6bb882c858e3a27f1.svg";